__turbopack_context__.v({
  "container": "-ls_zG_container",
  "icon": "-ls_zG_icon",
});
